module.exports = __webpack_public_path__ + "img/image (22).d8dec659.webp";